module.exports = __webpack_public_path__ + "img/dessinat-microtech-NR-052.e29427d7.jpg";